import {Injectable} from '@angular/core';
import { Router} from '@angular/router';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError,  map, switchMap, } from 'rxjs/operators';
import {error, success} from '../../shared/actions/toasts';
import {BaseEffect} from '../../shared/effects/base.effect';
import {debug} from '../../../rxjs-operators';
import { SendBackResult} from '../../shared';
import {of} from 'rxjs';
import {L10nTranslationService} from 'angular-l10n';
import {
  ProjectEditAction,
  projectEditActionTypes,
  ProjectEditFailAction,
  ProjectEditMismatchingFailAction,
  ProjectEditSuccessAction, ProjectEditWithOutAction
} from '../actions/project-creation';
import {ProjectCreationService} from '../services/project.service';
import {LoadProjectsAction} from '../../site/actions/projects-list';
import {LoadSubAnomalyListAction} from '../actions/subscription-list';

@Injectable()
export class ProjectCreationEffect extends BaseEffect {

  add$ = createEffect(() => { return this.actions$.pipe(
    ofType(projectEditActionTypes.CREATION),
    debug('creation project action received.'),
    map((action: ProjectEditAction) => action.payload),
    switchMap((payload) =>  this.projectCreationService.creation(payload).pipe(
      // tslint:disable-next-line:no-any
      switchMap((data: SendBackResult<any>) => of( new ProjectEditSuccessAction(data.data) , new LoadProjectsAction() )),
      catchError(res => this.catchResponseError(res))))
  ) });
  add2$ = createEffect(() => { return this.actions$.pipe(
    ofType(projectEditActionTypes.CREATION_W),
    debug('creation project action received.'),
    map((action: ProjectEditWithOutAction) => action.payload),
    switchMap((payload) =>  this.projectCreationService.creation(payload).pipe(
      // tslint:disable-next-line:no-any
      switchMap((data: SendBackResult<any>) => of( new ProjectEditSuccessAction(data.data), new LoadSubAnomalyListAction() )),
      catchError(res => this.catchResponseError(res))))
  ) });

  addSuccess$ = createEffect(() => { return this.actions$.pipe(
    ofType(projectEditActionTypes.CREATION_SUCCESS),
    debug('creation project action received.'),
    switchMap((data) => [
      success(this.translation.translate('PROJECT_LINK_SUCCESS'), this.translation.translate('TOAST_SUCCESS_TITLE'))

    ]),
  ) });


  addFail$ = createEffect(() => { return this.actions$.pipe(ofType(projectEditActionTypes.CREATION_FAIL),
    debug('A server error occurred while add contract.'),
    map((err: ProjectEditFailAction) =>
      error( (err.payload.search('Wrong project identifier') !== -1 ?
        this.translation.translate('PROJECT_LINK_MESSAGE_ERROR') : (err.payload ? err.payload : this.translation.translate('PROJECT_LINK_ERROR') )),
        this.translation.translate('TOAST_ERROR_TITLE'))))
  });
  addMismatchingFail$ = createEffect(() => { return this.actions$.pipe(ofType(projectEditActionTypes.CREATION_MISMATCHING_FAIL),
    debug('A server error occurred while add contract.'),
    map((err: ProjectEditMismatchingFailAction) =>
      // tslint:disable-next-line:no-unused-expression
      error(  this.translation.translate('PROJECT_CREATION_MISMATCHING_FAILED_1') + '  ' + err.payload[0]  + '  ' + this.translation.translate('PROJECT_CREATION_MISMATCHING_FAILED_2') + '  ' + err.payload[1]
        , this.translation.translate('TOAST_ERROR_TITLE'))))
  });

  constructor(private actions$: Actions,
              private translation: L10nTranslationService,
              private projectCreationService: ProjectCreationService,
              router: Router) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    if (response.error && response.error.translatableParams && response.error.translatableParams.length > 0) {
      return new ProjectEditMismatchingFailAction(response['error'].translatableParams);
    }

    return new ProjectEditFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new ProjectEditFailAction(response['error'].message);
  }
}
